import { Text } from "@bookingcom/bui-react";
import { t, useI18n } from "@bookingcom/lingojs-react";
import { InfoBoxCard } from "./CampaignImpactInfoBoxCard";
import styles from "../CampaignImpact.module.css";

export const CampaignImpactInfoBoxCardTrendingDown = () => {
  const i18n = useI18n();

  return (
    <InfoBoxCard
      backgroundColor="callout_alt"
      title={i18n.trans(t("flights_airline_portal_airline_view_campaign_error_conclusive_neg_header"))}
    >
      <Text variant="body_2">
        {i18n.trans(t("flights_airline_portal_airline_view_campaign_error_conclusive_neg_body"))}
      </Text>
      <ul className={styles.infoList}>
        <li>
          <Text variant="body_2">
            {i18n.trans(t("flights_airline_portal_airline_view_campaign_error_conclusive_neg_bullet_one"))}
          </Text>
        </li>
        <li>
          <Text variant="body_2">
            {i18n.trans(t("flights_airline_portal_airline_view_campaign_error_conclusive_neg_bullet_two"))}
          </Text>
        </li>
        <li>
          <Text variant="body_2">
            {i18n.trans(t("flights_airline_portal_airline_view_campaign_error_conclusive_neg_bullet_three"))}
          </Text>
        </li>
      </ul>
    </InfoBoxCard>
  );
};
